import type { DeviceRuntimeResourceState } from './resource-state';

export interface DeviceSettingsReadinessInput {
	deviceId: string | undefined;
	settings: unknown;
	resource?: DeviceRuntimeResourceState;
	/** @deprecated Use the device runtime resource state. */
	loading?: boolean;
}

export interface DeviceSettingsReadiness {
	ready: boolean;
	stale: boolean;
	phase: DeviceRuntimeResourceState['phase'];
	error?: unknown;
}

/**
 * Existing settings remain usable while a refresh is running or has failed.
 * A component is blocked only when the requested record has never been loaded.
 */
export function getDeviceSettingsReadiness({
	deviceId,
	settings,
	resource,
	loading = false,
}: DeviceSettingsReadinessInput): DeviceSettingsReadiness {
	const hasData = Boolean(deviceId) && settings !== undefined;
	const phase = resource?.phase ?? (loading ? 'loading' : hasData ? 'ready' : 'idle');

	return {
		ready: hasData,
		stale: hasData && (phase === 'loading' || phase === 'error'),
		phase,
		error: resource?.error,
	};
}

export function isDeviceSettingsReady(input: DeviceSettingsReadinessInput): boolean {
	return getDeviceSettingsReadiness(input).ready;
}
